<template>
  <div class="-the-tree">
    <!--suppress JSUnresolvedVariable -->
    <el-tree ref="tree" default-expand-all
             :data="tree"
             node-key="id"
             :expand-on-click-node="false"
             :filter-node-method="filterNode"
             :render-content="renderContent"
             :load="loadNode"
             @node-collapse="nodeCollapse"
             @node-click="handleNodeClick"
    />
  </div>
</template>

<script>
  export default {
    name: 'device-tree',
    props: {
      filterKey: {
        type: String,
        default: ''
      },
      title: {
        type: String,
        default: '标题'
      },
      keyName: {
        type: String,
        default: '键名'
      },
      showPopBox: {
        type: Boolean,
        default: true
      },
      maxDepth: {
        type: Number,
        default: 4
      },
      options: {
        type: Object,
        default () {
          return {
            1: [],
            2: ['add'],
            3: ['add', 'patch', 'delete'],
            4: ['patch', 'delete']
          }
        }
      },
      update: {
        type: Object,
        default () {
          return {
            render: () => [],
          }
        }
      }
    },
    watch: {
      'filterKey' (val) {
        this.$refs.tree.filter(val)
      }
    },
    data () {
      return {
        tree: [],
        showDev: false,
        treeData: [],
        treeFromServer: [],
        detailForm: {
          title: '添加营业单位',
          show: false,
          then: () => {
          },
          type: ''
        }
      }
    },
    created () {
      this.render('0')
    },
    methods: {
      filterNode (value, data) {
        if (!value) return true
        return data._label.indexOf(value) !== -1
      },
      render (code) {
        if (code !== null) {
          this.update.render(code)
            .then(list => {
              for (let n = 0; n < list.length; n++) {
                if (list[n].parentCode === '0') {
                  list[n]._className = 'cmy'
                } else {
                  if (list[n].type === '1') {
                    list[n]._className = 'cpy'
                  } else if (list[n].type === '2') {
                    list[n]._className = 'dev'
                  }
                }
              }
              let newArr = []
              for (let i = 0; i < this.treeData.length; i++) {
                if (this.treeData[i].parentCode !== code) {
                  newArr.push(this.treeData[i])
                }
              }
              this.treeData = newArr
              this.treeData.push.apply(this.treeData, list)
              // let maxParentID = 0
              // for (let j = 0; j < this.treeData.length; j++) {
              //   if (this.treeData[j].parentId > maxParentID) {
              //     maxParentID = this.treeData[j].parentId
              //   }
              // }
              // for (let k = 0; k < this.treeData.length; k++) {
              //   if (this.treeData[k].parentId === maxParentID && this.treeData[k].id) {
              //     let weakData = {
              //       id: '',
              //       level: this.treeData[k].level + 1,
              //       label: '',
              //       _label: '',
              //       name: '',
              //       parentId: this.treeData[k].id
              //     }
              //     newArr.push(weakData)
              //   }
              // }
              // this.treeData = newArr
              // setTimeout(() => {
              this.convertData()
              if (list.length === 1 && list[0].parentCode == 0) {
                this.render(list[0].code)
              }
              // })
            })
        }
      },

      convertData () {
        /**
         * 组装节点
         * @function
         * @param nodes
         */
        const packNode = (nodes) => {
          const getNodes = nodeId =>
            this.treeData.filter(n => n.parentCode === nodeId)

          nodes.forEach(node => {
            const children = getNodes(node.code)
            node.children = children
            if (children.length > 0) {
              packNode(children)
            }
          })
        }
        /**
         * 格式化原始数据
         */
        this.treeData
          .forEach(it => {
            it.edidable = false
            it.label = it._label
          })

        /**
         * 生成顶层节点
         */
        const tree = this.treeData.filter(tree => tree.parentCode == 0)
        /**
         * 开始组装节点
         */
        packNode(tree)

        this.tree = tree
      },
      copyObj (obj) {
        var newobj = {}
        for (var attr in obj) {
          newobj[attr] = obj[attr]
        }
        return newobj
      },
      nodeCollapse (data, node, $event) {
        // data.children = []
        // node.childNodes = []
        // for (let y = 0; y < this.treeData.length; y++) {
        //   if (this.treeData[y].parentId === data.id) {
        //     this.treeData.splice(y, 1, [])
        //   }
        // }
        // this.render(data.parentCode)
      },
      handleNodeClick ($event) {
        window.sessionStorage.setItem('scenceCode', $event.scence)
        console.log($event.deviceType)
        if ($event.deviceType === '3' || $event.deviceType === '4') {
          window.sessionStorage.setItem('deviceUse', '1')
        } else if ($event.deviceType === '1' || $event.deviceType === '2' || $event.deviceType === '5' || $event.deviceType === '6') {
          window.sessionStorage.setItem('deviceUse', '2')
        } else {
          window.sessionStorage.setItem('deviceUse', '')
        }
        if ($event.type !== '1' && $event.code) {
          window.sessionStorage.setItem('devType', $event.code)
        } else {
          window.sessionStorage.setItem('devType', '')
        }
        this.render($event.code)
        if ($event.code) {
          this.$emit('selected', $event.code, $event.deviceType)
        }
        // const currentId = $event.id
        // const isChecked = this.$refs.tree.getCheckedKeys().includes(currentId)
        // const checkedKeys = isChecked ? [] : [currentId]
        // this.$refs.tree.setCheckedKeys(checkedKeys)
        // this.$emit('selected', $event)
      },
      renderContent (h, { node, data, store }) {
        let _class
        if (data._className === 'cmy') {
          _class = 'el-icon-damai-yuanqu1'
        } else if (data._className === 'cpy') {
          _class = 'el-icon-damai-fangjianguanli'
        } else if (data._className === 'dev') {
          _class = 'el-icon-mobile-phone'
        }
        return (
          <span class="custom-tree-node">
            <i class={_class}></i>
            <span class="left" title={data._label}>{data._label}</span>
          </span>)
      },
      loadNode (node, resolve) {
      }
    }
  }
</script>

<style scoped>
  .el-tree{
    height: 710px!important;
    overflow-y: auto;
  }
</style>

<style lang="less">
  .el-tree-node > .el-tree-node__children {
    overflow: visible;
  }

  .-the-tree {
    overflow: hidden;
    .item {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 8px;
    }
    .custom-tree-node {
      display: flex;
      justify-content: flex-start;
    }
    .custom-tree-node i{
      font-size: 14px;
      line-height: 25px;
    }
    .left {
      display: block;
      text-align: left;
      min-width: 100px;
      line-height: 25px;
      max-width: 160px;
      margin-left: 3px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      user-select: none;
    }
    .icon-more {
      display: block;
      font-size: 12px;
      color: #999999;
      position: relative;
      padding: 4px;
      overflow: visible;
      margin-right: 60px;
      .pop-box {
        display: none;
        background-color: #fff;
        width: 48px;
        position: absolute;
        top: 10px;
        left: 20px;
        user-select: none;
        z-index: 2018;
      }
      .operate {
        display: none;
        font-size: 12px;
        color: #999999;
        padding: 5px;
        margin-top: -1px;
        border: 1px solid #999999;
      }
      .operate:hover {
        color: #1362FF;
        border: 1px solid #1362FF;
      }
      &.show .pop-box {
        display: block !important;
        .operate {
          display: block !important;
        }
      }
    }
  }
</style>

<style lang="less">
  label {
    margin-bottom: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Tree/device-tree.vue